/**
 * TVL 功能开关配置
 * 
 * 这个文件用于控制所有与 TVL (Total Value Locked) 相关功能的显示
 * 当需要重新启用 TVL 功能时，只需要修改这里的配置即可
 */

export const TVL_FEATURES_CONFIG = {
  // 控制 TopPools 组件的显示
  showTopPools: false,
  
  // 控制 TVL 排序选项的显示
  showTvlSorting: false,
  
  // 控制 TVL 列在表格中的显示
  showTvlColumn: false,
  
  // 控制 Volume/TVL 比率列的显示
  showVolOverTvlColumn: false,
  
  // 控制 ExploreStats API 查询的启用
  enableExploreStatsQuery: false,
  
  // 控制 ProtocolStats API 查询的启用
  enableProtocolStatsQuery: false,
} as const

/**
 * 获取 TVL 功能是否启用
 */
export function isTvlFeatureEnabled(feature: keyof typeof TVL_FEATURES_CONFIG): boolean {
  return TVL_FEATURES_CONFIG[feature]
}

/**
 * 检查是否有任何 TVL 功能被启用
 */
export function isAnyTvlFeatureEnabled(): boolean {
  return Object.values(TVL_FEATURES_CONFIG).some(Boolean)
}
